import {WlMultipleComponents} from "./multipleComponents.component";

export * from './multipleComponents.component';
export default WlMultipleComponents;

customElements.define('wl-multiple-components', WlMultipleComponents);